import { useLayoutEffect } from "react";
import { useDispatch } from "react-redux";

import type { ExchangeBetslipPreferences, SportsbookBetslipPreferences } from "../../../contract";
import {
  BETSLIP__EXC_PREFERENCES_RECEIVED,
  BETSLIP__SBK_PREFERENCES_RECEIVED,
  type ExchangePreferencesReceivedAction,
  type SportsbookPreferencesReceivedAction,
} from "./preferences-actions";

export function useSportsbookPreferencesSync(preferences: SportsbookBetslipPreferences): void {
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch<SportsbookPreferencesReceivedAction>({ type: BETSLIP__SBK_PREFERENCES_RECEIVED, payload: preferences });
  }, [dispatch, preferences]);
}

export function useExchangePreferencesSync(preferences: ExchangeBetslipPreferences): void {
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch<ExchangePreferencesReceivedAction>({ type: BETSLIP__EXC_PREFERENCES_RECEIVED, payload: preferences });
  }, [dispatch, preferences]);
}
